import React from "react";
import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/components/EventsAwardsAccordionHeader";
import { LINKIDIN_URL_SCA, SID_URL } from "@util/constant";

/**
 * Component to render Singapore Institute of Directors section on Partners page
 */
const SIDSection = (): React.ReactElement => {
  return (
    <div className="bg-gray-150" data-testid="sid-section-component">
      <AccordionV2
        testId="sid"
        className="border-x py-4"
        headerChildren={
          <EventsAwardsAccordionHeader title="Singapore Institute of Directors" />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mt-4 border-t border-gray-175 px-6 py-4 pt-4">
          <p>About the Singapore Institute of Directors</p>

          <p>
            The Singapore Institute of Directors (SID) is Singapore&apos;s
            national association for company directors. Formed in 1998, its
            mission is to uplift the directorship profession and champion good
            governance. Its membership comprises board directors, company
            leaders, and professionals with an interest in corporate governance.
            SID provides a comprehensive training curriculum that covers the
            spectrum of professional developmental needs of directors including
            the Listed Entity Director programme for newly-appointed directors
            and the Governance for Outstanding Organisation Directors programme
            for directors of nonprofit boards. In its advocacy for good
            governance, SID curates thought leadership and benchmarking research
            and indices on corporate governance and directorship issues, and
            provides a one-stop information resource on governance-related
            matters. It connects the director community via initiatives such as
            mentoring and networking, and provides a range of services for
            boards including board appointments, board listings and board
            evaluations.
          </p>

          <p>
            For more information, visit&nbsp;
            <a
              className="text-blue-175 hover:text-gray-750"
              href={SID_URL}
              target="_blank"
              rel="noreferrer"
            >
              www.sid.org.sg
            </a>
            &nbsp;and&nbsp;
            <a
              className="text-blue-175 hover:text-gray-750"
              href={LINKIDIN_URL_SCA}
              target="_blank"
              rel="noreferrer"
            >
              LinkedIn page
            </a>
            .
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default SIDSection;
